var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllowanceActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10.5H11.5",
    stroke: "#399E79",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4975 13.625C26.4975 13.5288 26.5 12.9588 26.4975 12.9188C26.4525 12.2925 25.9163 11.7937 25.2413 11.7525C25.1975 11.75 25.1463 11.75 25.0413 11.75H21.7888C19.5575 11.75 17.75 13.4288 17.75 15.5C17.75 17.5712 19.5587 19.25 21.7875 19.25H25.0413C25.1463 19.25 25.1975 19.25 25.2413 19.2475C25.9163 19.2062 26.4537 18.7075 26.4975 18.0813C26.5 18.0413 26.5 17.4712 26.5 17.375",
    stroke: "#399E79",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 16.75C22.1904 16.75 22.75 16.1904 22.75 15.5C22.75 14.8096 22.1904 14.25 21.5 14.25C20.8096 14.25 20.25 14.8096 20.25 15.5C20.25 16.1904 20.8096 16.75 21.5 16.75Z",
    fill: "#399E79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 25.4999H15.25C19.9637 25.4999 22.3212 25.4999 23.785 24.0349C24.7962 23.0249 25.11 21.5899 25.2063 19.2499M25.2063 11.7499C25.1088 9.40993 24.7962 7.97493 23.785 6.96493C22.3212 5.49993 19.9637 5.49993 15.25 5.49993H11.5C6.78625 5.49993 4.42875 5.49993 2.965 6.96493C1.50125 8.42993 1.5 10.7862 1.5 15.4999C1.5 20.2137 1.5 22.5712 2.965 24.0349C3.78125 24.8524 4.875 25.2137 6.5 25.3724M6.5 5.49993L11.1687 2.40368C11.8255 1.97706 12.5918 1.75 13.375 1.75C14.1582 1.75 14.9245 1.97706 15.5813 2.40368L20.25 5.49993",
    stroke: "#399E79",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllowanceActiveIcon);
export default __webpack_public_path__ + "static/media/allowanceActiveIcon.07a14145195871000efa189490fec450.svg";
export { ForwardRef as ReactComponent };